import * as React from 'react'

/**
 * Custom hook to manage refetching logic.
 * Provides a stable `refetch` function and a way to update the refetch function.
 */
export const useRefetch = () => {
  const ref = React.useRef<(() => Promise<void>) | null>(null);

  /**
   * Updates the current refetch function.
   * Memoized to prevent unnecessary re-renders.
   */
  const handleRefetchChange = React.useCallback((refetch: () => Promise<void>) => {
		ref.current = refetch;
	}, []);

  /**
   * Calls the current refetch function if it exists.
   * Memoized to provide a stable function reference.
   */
  const refetch = React.useCallback(async (): Promise<void> => {
    await ref.current?.();
  }, []);

  return {
    handleRefetchChange,
    refetch,
  };
}
